/* eslint-disable import/prefer-default-export */
export const LOGIN_FORM_TYPES = {
  SIGNUP: 'signup',
  SIGNIN: 'signin',
  FORGOT_PASSWORD: 'forgotPassword',
};

export const LOGIN_FORM_TYPES_SWITCH = {
  [LOGIN_FORM_TYPES.SIGNUP]: LOGIN_FORM_TYPES.SIGNIN,
  [LOGIN_FORM_TYPES.SIGNIN]: LOGIN_FORM_TYPES.SIGNUP,
  [LOGIN_FORM_TYPES.FORGOT_PASSWORD]: LOGIN_FORM_TYPES.SIGNIN,
};

export const LOGIN_FORM_TYPE_PARAMETER = 'form_type';



// WEBPACK FOOTER //
// ./constants/Login.js